module.exports = __webpack_public_path__ + "media/head_map4.d4b5b7da.mp4";